import Login from "../features/Authentication/Login";

const UnauthLayout = () => {
  return <Login />;
};

export default UnauthLayout;
